import React from 'react'
import classPic from '../assets/inclass.jpg'
import poultryPic from '../assets/poultryPic.jpg'
import computersPic from "../assets/computers.png"
import { CardWithImage, List } from '../components'

const About = () => {
  const about = [
    {
      image: classPic,
      title: "Our Aim",
      description: <List />
    },
    {
      image: poultryPic,
      title: "Our Goal",
      description: "To ensure inclusive economic development that is resilient to future crises and shocks, and contributes to realizing the Sustainable Development Goals"
    },
    {
      image: computersPic,
      title: "Our Approach",
      description: "The hub utilizes E-Learning to provide group lessons to young individuals, using smartphones and tablets as a digital platform. By employing technology, they aim to change the perception of the agricultural sector among young Africans and create previously unseen opportunities."
    },
  ]

  return (
    <div className={`h-full w-full text-center py-7 overflow-hidden`}>
      <h1 className='text-[28pt] font-semibold'>About Us</h1>
      <div className='w-full flex flex-row items-center justify-start text-black p-3 md:ml-20'>
        <p className='p-2 text-lg font-light w-[375px] text-justify'>
          The hub acknowledges the importance of youth as managers of our agrifood systems through re-engaging 
          youth towards agriculture with integrated innovated agricultural systems like farm mechanization
        </p>
      </div>
      <div className={`flex md:flex-row w-full justify-evenly items-center flex-wrap mt-6 gap-y-5`}>
        {
          about.map((data, value) => (
            <CardWithImage image={data.image} title={data.title} description={data.description}/>
          ))
        }
        

      </div>
    </div>
  )
}

export default About
